import * as React from 'react'
import {
  LightTabs,
  LightTab,
  LightTabsBody,
  LightTabBody,
} from '@cloudflare/light-tabs'
import { PaneContainer, Pane, PaneHandle } from '@cloudflare/draggable-pane'
import { TEWRequest } from '@cloudflare/cf-edgeworker-http-request-editor'

import { FlexPassthrough, Border } from './common'
import { FiddleDevTools } from './FiddleDevTools'
import { FiddleUrlBar } from './FiddleUrlBar'
import { FiddleResult } from './FiddleResult'
import { RawRequestPane } from './RawRequestPane'

import { TPreviewProps, IRawRequestResponse } from '../lib/FiddleService'
import { RUNTIME_BASE_URL } from '../lib/config'

const RUNTIME_HOST = new URL(RUNTIME_BASE_URL).host
const RUNTIME_SECURE = new URL(RUNTIME_BASE_URL).protocol === 'https:'

export interface IFiddlePreviewAreaProps {
  preview: TPreviewProps
  getPreviewId: (props: TPreviewProps) => string
  getPreviewUrl: (props: TPreviewProps) => string
  runRawRequest: (props: TPreviewProps) => Promise<IRawRequestResponse>
  activePreviewTab: string
  isPreviewPaneLoading: boolean
  sidebarIsMoving: boolean
  devtoolsIsMoving: boolean
  fiddleDidMakeFixGCLBRequest: boolean
  devToolsPaneHeight: number
  pathToMonaco: string
  onRequestDevToolsPaneChange: (target: number) => void
  onDevtoolsPaneMouseDown: () => void
  onDevtoolsPaneMouseUp: () => void
  onPreviewPaneTabChange: (id: string) => void
  onRequestChange: (req: Partial<TEWRequest>) => void
  onRequestSubmit: () => void
}

export class FiddlePreviewArea extends React.Component<
  IFiddlePreviewAreaProps
> {
  constructor(props: IFiddlePreviewAreaProps) {
    super(props)
    this.onUrlChange = this.onUrlChange.bind(this)
  }

  onUrlChange(url: string) {
    this.props.onRequestChange({ url })
  }

  render() {
    const { props } = this

    return (
      <FlexPassthrough direction="column">
        <PaneContainer
          direction="column"
          onRequestMove={props.onRequestDevToolsPaneChange}
          onMouseDown={props.onDevtoolsPaneMouseDown}
          onMouseUp={props.onDevtoolsPaneMouseUp}
        >
          <Pane>
            <LightTabs
              active={props.activePreviewTab}
              onChange={props.onPreviewPaneTabChange}
            >
              <LightTab id="preview">Preview</LightTab>
              <LightTab id="testing">Testing</LightTab>
              <LightTab
                id="documentation"
                href="https://workers.cloudflare.com/docs/"
              >
                Documentation
              </LightTab>
            </LightTabs>
            <LightTabsBody active={props.activePreviewTab}>
              <Border borderTopWidth="1px" direction="column">
                <LightTabBody id="preview" shouldUnmountOnChange={false}>
                  <FiddleUrlBar
                    onChange={this.onUrlChange}
                    onSubmit={props.onRequestSubmit}
                    value={props.preview.request.url}
                    isLoading={props.isPreviewPaneLoading}
                  />
                  {props.preview.scriptId && (
                    <FiddleResult
                      isActive={props.activePreviewTab === 'preview'}
                      getPreviewId={props.getPreviewId}
                      getPreviewUrl={props.getPreviewUrl}
                      preview={props.preview}
                    />
                  )}
                </LightTabBody>
                <LightTabBody id="testing" shouldUnmountOnChange={false}>
                  <RawRequestPane
                    isActive={props.activePreviewTab === 'testing'}
                    shouldHideEditorOverflow={
                      props.sidebarIsMoving || props.devtoolsIsMoving
                    }
                    pathToMonaco={props.pathToMonaco}
                    getPreviewId={props.getPreviewId}
                    runRawRequest={props.runRawRequest}
                    preview={props.preview}
                    onChange={props.onRequestChange}
                    onSubmit={props.onRequestSubmit}
                  />
                </LightTabBody>
                <LightTabBody id="documentation" shouldUnmountOnChange={false}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      flex: 1,
                      width: '100%',
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      overflow: 'hidden',
                    }}
                  >
                    <iframe
                      style={{
                        flex: 1,
                        width: '100%',
                        border: 'none',
                        padding: 0,
                        margin: 0,
                        marginTop: '-72px',
                      }}
                      src="https://workers.cloudflare.com/docs/"
                    />
                  </div>
                </LightTabBody>
              </Border>
            </LightTabsBody>
          </Pane>
          {props.preview.scriptId && props.fiddleDidMakeFixGCLBRequest && (
            <PaneHandle current={props.devToolsPaneHeight} />
          )}
          {props.preview.scriptId && props.fiddleDidMakeFixGCLBRequest && (
            <Pane height={`${props.devToolsPaneHeight}px`}>
              <FiddleDevTools
                previewUpdateCount={props.preview.updateCount}
                sessionId={props.preview.sessionId}
                host={RUNTIME_HOST}
                secure={RUNTIME_SECURE}
                onReloadRequest={props.onRequestSubmit}
              />
            </Pane>
          )}
        </PaneContainer>
      </FlexPassthrough>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FiddlePreviewArea.tsx